import { render, staticRenderFns } from "./tuijian.vue?vue&type=template&id=26dc1299&"
import script from "./tuijian.vue?vue&type=script&lang=js&"
export * from "./tuijian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports